// utils/InvoiceHtml.ts
import { ILead, ILeadReq, IDropdown } from "../models/BaseModel";
import { format } from "date-fns";
interface IPackageDrop extends IDropdown {
    duration: number
}
interface IRoomTypeDrop extends IDropdown {
    capacity: number
    mattress: number
}
interface IBoatingLocationDrop extends IDropdown {
    capacity: number
}
interface IVehicleTypeDrop extends IDropdown {
    capacity: number
}
interface IPickupLocationDrop extends IDropdown {
    distance: number
}
interface IBoatings {
    id?: number,
    boatingLocationId?: number,
    noOfPeople?: number
}
interface IFoodPackagePrice extends IDropdown {
    price: number,
    desc?: string
}
export function generateInvoiceHtml(
    lead: ILead,
    req: ILeadReq,
    lookups?: {
        purposeOfTrip?: IDropdown[];
        packages?: IPackageDrop[];
        roomTypes?: IRoomTypeDrop[];
        boatingLocations?: IBoatingLocationDrop[];
        vehicleTypes?: IVehicleTypeDrop[];
        pickupLocations?: IPickupLocationDrop[];
        foodPackagePrice?: IFoodPackagePrice[];

    }
): string {
    const {
        purposeOfTrip,
        packages,
        roomTypes,
        boatingLocations,
        vehicleTypes,
        pickupLocations,
        foodPackagePrice
    } = lookups || {};
    //     lead: ILead,
    //     req: ILeadReq,
    //     purposeOfTrip?: IDropdown[],
    //     packages?: IPackageDrop[],
    //     roomTypes?: IRoomTypeDrop[],
    //     boatingLocations?: IBoatingLocationDrop[],
    //     vehicleTypes?: IDropdown[],
    //     pickupLocation?: IPickupLocationDrop[],
    //     foodPackagePrice?: { name: string; price: number }[]
    // ): string {
    let roomsTotalPrice = 0;
    let boatingsTotalPrice = 0;
    let pickAndDropTotalPrice: number[] = [];
    let vehiclesTotalPrice = 0;
    let foodPackageTotalPrice = 0;

    const boatRequired = (boating: any) => {
        const boatDetails = boatingLocations?.find(e => e.id === boating.boatingLocationId);
        if (boatDetails && boating.noOfPeople) {
            return Math.ceil(boating.noOfPeople / boatDetails.capacity);
        }
        return 0;
    };

    function calculateDayNightCount(start: Date, end: Date) {
        const startTime = start.getTime();
        const endTime = end.getTime();
        if (endTime <= startTime) return { dayCount: 0, nightCount: 0 };

        let current = new Date(start);
        let dayCount = 0;
        let nightCount = 0;

        while (current.getTime() < endTime) {
            const hour = current.getHours();
            const isDayTime = hour >= 6 && hour < 18;
            if (isDayTime) dayCount++;
            else nightCount++;
            current = new Date(current.getTime() + 12 * 60 * 60 * 1000);
        }
        return { dayCount, nightCount };
    }

    // Start HTML
    let html = `
    <html>
    <head>
      <style>
        body { font-family: 'Open Sans', Arial, sans-serif; line-height: 1.5; color: #333; }
        h1,h2,h3 { color: #444; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
        th { background: #f0f0f0; }
        .total { font-weight: bold; color: #c00000; }
      </style>
    </head>
    <body>
      <p>Hello <b>${lead.contactName || '-'}</b>,</p>
      <p>Greetings from <b>Jungle Avengers Resort</b>! Here is your detailed invoice for your upcoming trip:</p>
      
      <h2>Invoice</h2>
      <p><b>Contact:</b> ${lead.contactName || '-'} | ${lead.contactContact || '-'}</p>
      <p><b>Purpose:</b> ${purposeOfTrip?.find(e => e.id === req.purposeOfTripId)?.name || "-"}</p>
      <p><b>Package:</b> ${packages?.find(e => e.id === req.packageId)?.name || "-"}</p>
      <p><b>Check-in:</b> ${req.checkin ? format(new Date(req.checkin), "d MMMM yyyy (EEEE)") : "-"}</p>
      <p><b>Check-out:</b> ${req.checkout ? format(new Date(req.checkout), "d MMMM yyyy (EEEE)") : "-"}</p>
      <p><b>Adults:</b> ${req.noOfAdults || 0} | <b>Children (7–12 yrs):</b> ${req.noOfChildren || 0}</p>
    `;

    // Rooms
    html += `<h3>Rooms</h3><table>
        <tr>
          <th>Room Type</th>
          <th>Price/Day</th>
          <th>Quantity</th>
          <th>Mattress</th>
          <th>Total</th>
        </tr>`;

    req.rooms?.forEach(room => {
        const roomType = roomTypes?.find(e => e.id === room.roomTypeId);
        const _package = packages?.find(e => e.id === req.packageId);
        if (roomType && _package) {
            const duration = _package.duration / 24;
            const price = ((room.mattress * room.mattressPrice) + (room.count * room.price)) * duration;
            roomsTotalPrice += price;
            html += `
            <tr>
              <td>${roomType.name}</td>
              <td>${room.price} * ${duration}</td>
              <td>${room.count}</td>
              <td>${room.mattress ? `${room.mattress} * ${room.mattressPrice} * ${duration}` : 0}</td>
              <td>${price.toFixed(2)}</td>
            </tr>`;
        }
    });

    html += `<tr><td colspan="4" align="right">Total</td><td>${roomsTotalPrice.toFixed(2)}</td></tr></table>`;

    // Boating
    // html += `<h3>Boating: ${req.boatings ? "Yes" : "No"}</h3>`;
    // if (req.boatings) {
    //     html += `<table>
    //       <tr><th>Destination</th><th>Passengers</th><th>Price/Boat</th><th>Total</th></tr>`;
    //     req.boatings?.forEach(boating => {
    //         const boatingLocation = boatingLocations?.find(e => e.id === boating.boatingLocationId);
    //         if (boatingLocation) {
    //             const price = boating.price * boatRequired(boating);
    //             boatingsTotalPrice += price;
    //             html += `
    //             <tr>
    //               <td>${boatingLocation.name} - ${boating.time ? format(new Date(boating.time), "d MMMM") : ""}</td>
    //               <td>${boating.noOfPeople || 0}</td>
    //               <td>${boating.price} * ${boatRequired(boating)}</td>
    //               <td>${price.toFixed(2)}</td>
    //             </tr>`;
    //         }
    //     });
    //     html += `<tr><td colspan="3" align="right">Total</td><td>${boatingsTotalPrice.toFixed(2)}</td></tr></table>`;
    // }

    // Pickup / Drop
    html += `<h3>Pickup / Drop: ${req.pickAndDrops ? "Yes" : "No"}</h3>`;
    if (req.pickAndDrops) {
        req.pickAndDrops?.forEach(pickAndDrop => {
            const location = pickupLocations?.find(e => e.id === pickAndDrop.pickupLocationId);
            if (location) {
                html += `<p><b>${pickAndDrop.tripType.toUpperCase()}</b> | ${pickAndDrop.time ? format(new Date(pickAndDrop.time), "d MMMM hh:mm a") : ""}
                ${pickAndDrop.tripType === "roundtrip" && pickAndDrop.endtime ? " - " + format(new Date(pickAndDrop.endtime), "d MMMM hh:mm a") : ""}
                | ${pickAndDrop.noOfPeople || 0} Passengers | ${location.name} | ${location.distance || 0} Km</p>`;
            }
        });
    }

    // Food
    html += `<h3>Meal Plan: ${req.mealPlan || '-'}</h3>`;
    if (req.mealPlan === "Food package") {
        const _package = packages?.find(e => e.id === req.packageId);
        const duration = (_package?.duration ?? 24) / 24;
        html += `<table>
          <tr><th>Food Package</th><th>Price/Day</th><th>Qty</th><th>Total</th></tr>`;

        const types = [
            { key: "AdultVeg", label: "Veg Adult", quantity: req.vegAdult ?? 0 },
            { key: "AdultNonVeg", label: "NonVeg Adult", quantity: req.nonVegAdult ?? 0 },
            { key: "AdultJain", label: "Jain Adult", quantity: req.jainAdult ?? 0 }
        ];
        if (req.noOfChildren) {
            types.push({ key: "ChildVeg", label: "Veg Child", quantity: req.vegChild ?? 0 });
            types.push({ key: "ChildNonVeg", label: "NonVeg Child", quantity: req.nonVegChild ?? 0 });
            types.push({ key: "ChildJain", label: "Jain Child", quantity: req.jainChild ?? 0 });
        }

        types.forEach(t => {
            const price = foodPackagePrice?.find(e => e.name === t.key)?.price ?? 0;
            const total = price * t.quantity * duration;
            foodPackageTotalPrice += total;
            html += `
            <tr>
              <td>${t.label}</td>
              <td>${price} * ${duration}</td>
              <td>${t.quantity}</td>
              <td>${total.toFixed(2)}</td>
            </tr>`;
        });

        html += `<tr><td colspan="3" align="right">Total</td><td>${foodPackageTotalPrice.toFixed(2)}</td></tr></table>`;
    }

    // Totals
    const final = roomsTotalPrice + boatingsTotalPrice + pickAndDropTotalPrice.reduce((acc, price) => acc + price, 0) + vehiclesTotalPrice + foodPackageTotalPrice;
    const gst = (final * 18) / 100;

    html += `
      <h3>Totals</h3>
      <p>Total: ${final.toFixed(2)} Rs.</p>
      <p>GST (18%): ${gst.toFixed(2)} Rs.</p>
      <p class="total">Final Total: ${(final + gst).toFixed(2)} Rs.</p>
      <p>We look forward to welcoming you to Jungle Avengers Resort. Have a wonderful trip!</p>
    </body></html>`;

    return html;
}
